import React from "react";
import './case-study-detail.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import CwContentViewer from "../../common/cw-content-viewer/cw-content-viewer";
import SchoolApi from "../../../apis/school";
import SessionCache from "../../routes/session-cache";



class CaseStudyDetail extends React.Component {


    state = {
        showQuestionDetail: false,
        showConceptList: false,
        showScenarioList: false,
        pdfDownloadLink: ''
    }


    constructor(props) {
        super(props)
        // console.log(this.props.caseStudyInfo)

        // this.generateCaseStudyPdf()
        this.user = SessionCache.getUser()
        console.log(this.user)
    }

    componentDidMount() {
        const element = document.getElementById("case-study-detail-page-scroll-to-top");
        element.scrollIntoView({behavior: "instant", block: "start", inline: "nearest" });
    }

    generateCaseStudyPdf() {
        let payload = {
            chapterTitle: this.props.chapterTitle,
            selectedClass: this.props.selectedClass,
            practiceQuestionId: this.props.caseStudyInfo._id
        }

        SchoolApi.generateCaseStudyPdf(payload).then(res => {
            console.log(res)

            this.setState({ pdfDownloadLink: res.webLink })

        }).catch(err => {
            console.log(err)
        })


    }



    toggleBack = () => {

        this.props.back && this.props.back()
    }

    toggleMenu(key) {

        if (key === 'case_study_question_expand') {
            this.setState({ showQuestions: !this.state.showQuestions })
        } else if (key === 'case_study_solution') {
            this.setState({ showQuestionDetail: !this.state.showQuestionDetail })
        } else if (key === 'case_study_concept_covered') {
            this.setState({ showConceptList: !this.state.showConceptList })
        } else if (key === 'case_study_scenario') {
            this.setState({ showScenarioList: !this.state.showScenarioList })
        }


    }

    goToChapterListScreen = () => {
        this.props.goToChapterListScreen && this.props.goToChapterListScreen()
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb '>
                <span className='bread-crumb-title' onClick={() => this.toggleBack()}>{`Chapter : ${this.props.chapterTitle || ""} | `}</span>
                <span className="bread-crumb-title pl-2" onClick={this.goToChapterListScreen}>{`${this.props.selectedClass || ""}`}</span>
                {/* <span className='pl-2'>{this.props.selectedElo?.conceptTitle} {`>`} </span>
                <span className='active pl-2'>{this.props.selectedElo?.title}</span> */}
            </div>
        )
    }

    render() {
        return (
            <div id="case-study-detail-page-scroll-to-top" className="case-study-detail">
                <div className='' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div>
                <div className="p-3">
                    <div className='row align-items-center heading-wrapper mt-2 p-2'>
                        {/* <img className="case-study-bg" src={getImageSource(ImageConstants.CASE_STUDY_BG)} /> */}
                        <div className='col-5 d-flex align-items-center'>
                            <div>
                                <img className='orange-play-icon mr-2' src={getImageSource(ImageConstants.CASE_STUDY_ICON)} />
                            </div>
                            <div>
                                <div className="header-text mb-0">{this.props.caseStudyInfo.questions.length ? <CwContentViewer content={this.props.caseStudyInfo.questions[0].caseStudyTitle} /> : 'Case Studies'}</div>
                                <div className=''>{this.renderBreadcrumb()}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="position-relative mt-3">
                    {/* <img className="video-detail-header-image" src={getImageSource(ImageConstants.VIDEO_DETAIL_HEADER_IMAGE)} /> */}

                    {
                        this.props.caseStudyInfo.questions.map((item) => (
                            <>
                                <div className="video-detail-wrapper">
                                    <div className="sub-heading d-flex align-items-center p-4">
                                        <span className="description-title">Case Study Description</span>
                                        {
                                            this.props.caseStudyInfo.webLink && this.user.schoolInfo.activationStatus?.status === 'ACTIVATED' ?
                                                <>
                                                    <a className="anchor-tag" download
                                                        href={this.props.caseStudyInfo.webLink} >
                                                        <img className="download-icon cursor-pointer mr-2" src={getImageSource(ImageConstants.CASE_STUDY_DOWNLOAD_ICON)}></img>
                                                    </a>
                                                </>
                                                :
                                                <></>
                                        }
                                        {/* <CwContentViewer from='case_study' content={item.caseStudyTitle} /> */}
                                        {/* <div className="ml-2">
                                            <img className="download-icon" src={getImageSource(ImageConstants.CASE_STUDY_DOWNLOAD_ICON)} />
                                        </div> */}
                                    </div>
                                    <div className="video-detail-divider"></div>
                                    <div className="question-title-info p-4">
                                        <div className="d-flex">
                                            <div>
                                                {
                                                    item.images.length ?
                                                        item.images.map(image => (
                                                            <img className="case-study-image" src={image.imageUrl} />
                                                        ))

                                                        : <></>
                                                }
                                            </div>
                                            <div className="question-description-text ml-3">
                                                <CwContentViewer content={item.title} />
                                            </div>

                                        </div>

                                        {
                                            item.conceptTitle && item.conceptTitle.length &&
                                            <div className="mt-3">
                                                <div className="concepts-covered-card">
                                                    {/* <img className="case-study-bg" src={getImageSource(ImageConstants.CASE_STUDY_QUESTION_BG)} /> */}
                                                    <div className={`question-title-wrapper d-flex justify-content-between align-items-center cursor-pointer p-3
                                                ${this.state.showConceptList ? '' : 'question-border-bottom-radius'}`} onClick={() => this.toggleMenu('case_study_concept_covered')}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="mr-2">
                                                                <img className="book-with-apple" src={getImageSource(ImageConstants.BLUE_BOOK_ICON)} />
                                                            </div>
                                                            <div className="heading">Concepts Covered </div>
                                                        </div>
                                                        <div>
                                                            <img className="arrow-size-for-case-study" src={getImageSource(this.state.showQuestions ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.showConceptList ?
                                                            <>
                                                                {/* <div className='divider'></div> */}
                                                                <div className=" question-and-answer">

                                                                    {
                                                                        item.conceptTitle && item.conceptTitle.length && item.conceptTitle.map(conceptTitle => (
                                                                            <div className="item ml-3">
                                                                                <div className="">{conceptTitle}</div>

                                                                            </div>
                                                                        ))
                                                                    }


                                                                </div>

                                                            </>
                                                            :
                                                            <></>
                                                    }
                                                    <div>

                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {
                                            item.scenario && <div className="mt-3">
                                                <div className="scenario-card">
                                                    {/* <img className="case-study-bg" src={getImageSource(ImageConstants.CASE_STUDY_QUESTION_BG)} /> */}
                                                    <div className={`question-title-wrapper d-flex justify-content-between align-items-center cursor-pointer p-3
                                                ${this.state.showScenarioList ? '' : 'question-border-bottom-radius'}`} onClick={() => this.toggleMenu('case_study_scenario')}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="mr-2">
                                                                <img className="book-with-apple" src={getImageSource(ImageConstants.CASE_STUDY_QUESTION_ICON)} />
                                                            </div>
                                                            <div className="heading">Scenarios </div>
                                                        </div>
                                                        <div>
                                                            <img className="arrow-size-for-case-study" src={getImageSource(this.state.showQuestions ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.showScenarioList ?
                                                            <>
                                                                {/* <div className='divider'></div> */}
                                                                <div className="">
                                                                    <div className="p-2 question-and-answer">
                                                                        <CwContentViewer content={item.scenario} />
                                                                    </div>
                                                                </div>

                                                            </>
                                                            :
                                                            <></>
                                                    }
                                                    <div>

                                                    </div>
                                                </div>
                                            </div>
                                        }





                                        <div className="mt-3">
                                            <div className="questions-and-solutions-card">
                                                {/* <img className="case-study-bg" src={getImageSource(ImageConstants.CASE_STUDY_QUESTION_BG)} /> */}
                                                <div className={`question-title-wrapper d-flex justify-content-between align-items-center cursor-pointer p-3
                                                ${this.state.showQuestions ? '' : 'question-border-bottom-radius'}`} onClick={() => this.toggleMenu('case_study_question_expand')}>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-2">
                                                            <img className="book-with-apple" src={getImageSource(ImageConstants.CASE_STUDY_QUESTION_ICON)} />
                                                        </div>
                                                        <div className="heading">Questions </div>
                                                    </div>
                                                    <div>
                                                        <img className="arrow-size-for-case-study" src={getImageSource(this.state.showQuestions ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                                    </div>
                                                </div>

                                                {
                                                    this.state.showQuestions ?
                                                        <>
                                                            {/* <div className='divider'></div> */}
                                                            <div className="">
                                                                <div className="p-2 question-and-answer">
                                                                    <CwContentViewer content={item.answer} />
                                                                </div>
                                                            </div>

                                                        </>
                                                        :
                                                        <></>
                                                }
                                                <div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <div className="solutions-card">
                                                {/* <img className="case-study-bg" src={getImageSource(ImageConstants.ELLIPSE_BLUE)} /> */}
                                                <div className={`solution-title-wrapper d-flex justify-content-between align-items-center cursor-pointer p-3
                                                ${this.state.showQuestionDetail ? '' : 'solution-border-bottom-radius'}`} onClick={() => this.toggleMenu('case_study_solution')}>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-2">
                                                            <img className="book-with-apple" src={getImageSource(ImageConstants.Q_A_ORANGE)} />
                                                        </div>
                                                        <div className="heading">Solution</div>
                                                    </div>
                                                    <div>
                                                        <img className="arrow-size-for-case-study" src={getImageSource(this.state.showQuestionDetail ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                                    </div>
                                                </div>

                                                {
                                                    this.state.showQuestionDetail ?
                                                        <>
                                                            {/* <div className='divider mt-1 mb-1'></div> */}
                                                            <div className="">
                                                                <div className=" question-and-answer">
                                                                    <CwContentViewer content={item.solution} />
                                                                </div>
                                                            </div>

                                                        </>
                                                        :
                                                        <></>
                                                }
                                                <div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <>

                                        {/* <div className="sub-heading mt-2">Questions</div>
                                    <CwContentViewer content={item.answer} />
                                    <div className="sub-heading mt-2">{`Solution`}</div>
                                    <CwContentViewer content={item.solution} /> */}
                                    </>
                                </div>

                            </>
                        ))
                    }




                </div>


            </div>
        )
    }

}

export default CaseStudyDetail;